import { render, staticRenderFns } from "./DealerBindDialog.vue?vue&type=template&id=b0b9bf3a&scoped=true"
import script from "./DealerBindDialog.vue?vue&type=script&lang=js"
export * from "./DealerBindDialog.vue?vue&type=script&lang=js"
import style0 from "./DealerBindDialog.vue?vue&type=style&index=0&id=b0b9bf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9bf3a",
  null
  
)

export default component.exports